import React, {useRef} from 'react';
import './App.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Container, Row } from 'react-bootstrap';
import Logo from './logo.png';
import Bruidswerk from './pages/bruidswerk/bruidswerk';
import Workshops from './pages/workshops/workshops';
import Contact from './pages/contact/contact';
import About from './pages/about/about';

function App() {
  const home = useRef();
  const bruidswerk = useRef();
  const workshops = useRef();
  const about = useRef();
  const contact = useRef();
  const navbar = useRef();

  function scrollIntoView(ref){
    const rect = navbar.current.getBoundingClientRect();
    const to = rect.height + 20;
    window.scrollTo({
      top: ref.current.offsetTop - to,
      behavior: 'smooth'
    });
    //console.log(to, ref.current.offsetTop);
    //ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  return (
    <React.Fragment>
      <Container className="d-none d-lg-block" ref={home}>
        <Row  className="justify-content-md-center">
          <img src={Logo} alt="Logo Elle Fleur"/>
        </Row>
        </Container>
    <Navbar bg="light" expand="lg" sticky="top" collapseOnSelect ref={navbar}>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
    <Nav>
      <Nav.Link href="#home" onClick={() => scrollIntoView(home)}>Home</Nav.Link>
      <Nav.Link href="#bruidswerk" onClick={() => scrollIntoView(bruidswerk)}>Bruidswerk</Nav.Link>
      <Nav.Link href="#workshops" onClick={() => scrollIntoView(workshops)}>Workshops</Nav.Link>
      <Nav.Link href="#about" onClick={() => scrollIntoView(about)}>Over mij</Nav.Link>
      <Nav.Link href="#contact" onClick={() => scrollIntoView(contact)}>Contact</Nav.Link>
    </Nav>
  </Navbar.Collapse>
  </Navbar>
  <Container fluid>
    <Bruidswerk ref={bruidswerk} />
    <Workshops ref={workshops} />
    <About ref={about} />
    <Contact ref={contact} /></Container>
  </React.Fragment>
  );
}

export default App;
